module.exports = __webpack_public_path__ + "img/84.39256cb4.jpg";